import { useQuery } from "react-query";
import { getData } from "../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { USE_MOCK } from "../appConstants";
import { IPaginatedResponse } from "../interfaces/response";

type TParams = {
  customerId: number;
  walletId: number;
  walletProvider: string;
  page: number;
  pageSize: number;
};

export interface ICustomerUnCompletedTransactions {
  transactionDate: string;
  amount: number;
  transactionType: string;
  description: string;
  currency: string;
  makerCheckerReference: string;
  makerCheckerStatus: string;
  status: string;
  pubDate: string;
  createdBy: string | null;
  recipientAccountNumber: string;
  recipientAccountName: string;
  recipientBankName: string;
}

export const getCustomerUncompletedTransactions = async ({
  customerId,
  page,
  pageSize,
  walletId,
  walletProvider,
}: TParams): Promise<
  IPaginatedResponse<ICustomerUnCompletedTransactions[]>
> => {
  if (USE_MOCK) {
    // Return mock data using setTimeout to simulate network delay
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          message: "Requests fetched successfully!",
          status: true,
          status_code: 200,
          page: 1,
          pageSize: 10,
          totalCount: 100,
          totalPages: 100,
          data: [
            {
              transactionDate: "2025-02-06T08:40:16.054779",
              amount: 70000,
              transactionType: "Debit",
              description: "table refresh",
              currency: "NGN",
              makerCheckerReference: "48edbfb8-e984-48f9-9017-af74af9d6fc5",
              makerCheckerStatus: "1",
              status: "Pending",
              pubDate: "2025-02-06T08:40:16.054779",
              createdBy: null,
              recipientAccountNumber: "9039488948",
              recipientAccountName: "John Doe Inc",
              recipientBankName: "Advancly Mfb",
            },
          ],
        });
      }, 5000);
    });
  }

  const { data } = await getData(
    `${ajaxEndpoints.DB_UNCOMPLETED_TRANSACTIONS}?page=${page}&pageSize=${pageSize}&customerId=${customerId}&walletId=${walletId}&walletProvider=${walletProvider}`
  );
  return data.data;
};

export const useCustomerUnCompletedTransactions = (params: TParams) => {
  return useQuery<
    IPaginatedResponse<ICustomerUnCompletedTransactions[]>,
    Error
  >(["getCustomerUncompletedTransactions", params], () =>
    getCustomerUncompletedTransactions(params)
  );
};
